import React from 'react';
import type { MessagingTrigger as Props } from './messaging-trigger.types';
import { useSalesforceMessaging } from './use-salesforce-messaging';

const MessagingTrigger: React.FC<Props> = ({
  init,
  prechat,
  settings,
  src,
}) => {
  useSalesforceMessaging(src, init, settings, prechat);
  return <React.Fragment />;
};

export default MessagingTrigger;
